
import React, { useEffect } from 'react';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import EntriesNocsTable from './EntriesNocsTable';
import { ALL_URL, PROCESSING_TYPE } from 'helpers/utils';


export default function EntriesBySportAndNoc({ data, isTeam }) {
    const [dataState, setDataState] = React.useState([]);
    const { mirs_discipline, mirs_noc, mirs_event } = useUrlFriendlyToParameters()
    useEffect(() => {
        let filterData = isTeam ? data : data?.filter(athlete => athlete?.mainFunction?.functionCode === 'AA01' || athlete?.mainFunction?.functionCode === 'AP01'); // Use data based on isTeam flag
        if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
            filterData = filterData?.filter((itemDiscipline) => {
                return isTeam ? (itemDiscipline?.discipline?.code === mirs_discipline) : (itemDiscipline?.disciplines?.find(disc => disc?.code === mirs_discipline)?.code);
            });
        }
        if (mirs_noc && mirs_noc !== ALL_URL.ALL_NOC) {
            filterData = filterData?.filter(itemOrganisation => itemOrganisation?.organisation?.code === mirs_noc);
        }
        let filteredResults = processFilteredData(filterData, isTeam ? PROCESSING_TYPE.TEAM : PROCESSING_TYPE.PERSON);
        setDataState(filteredResults);
    }, [data, isTeam, mirs_event, mirs_noc, mirs_discipline]);

    return (
        <>
            <EntriesNocsTable data={dataState} footerData={calculateFooterData(dataState)} />
        </>
    )
};
/**
 * Process filtered data and calculate gender counts by NOC (National Olympic Committee).
 *
 * @param {Array} filterData - The filtered data to process.
 * @param {string} dataType - The type of data ('person' or 'team').
 * @returns {Array} An array of processed data with gender counts by NOC.
 */
function processFilteredData(filterData, dataType) {
    // Initialize an empty array to store the processed data.
    const results = [];

    // Create an object to store gender counts for each organization (NOC code).
    const genderCountsByNOC = {};

    // Iterate through the filtered data to calculate gender counts.
    filterData?.forEach(dataItem => {
        let gender;
        let nocCode;

        // Check the data type and access the relevant properties accordingly.
        if (dataType === PROCESSING_TYPE.PERSON) {
            gender = dataItem?.personGender?.code;
            nocCode = dataItem?.organisation?.code;
        } else if (dataType === PROCESSING_TYPE.TEAM && dataItem?.athletes) {
            // Handle accessing athlete data within a team.
            dataItem?.athletes.forEach(athlete => {
                gender = athlete?.person?.personGender?.code;
                nocCode = dataItem?.organisation?.code;
                if (gender) {
                    // Initialize gender counts for each NOC if not already present.
                    if (!genderCountsByNOC[nocCode]) {
                        genderCountsByNOC[nocCode] = {
                            M: 0,
                            F: 0,
                            T: 0,
                        };
                    }

                    // Update gender-specific and total counts for the NOC.
                    genderCountsByNOC[nocCode][gender]++;
                    genderCountsByNOC[nocCode].T++;
                }
            });
        }

        if (gender&& dataType===PROCESSING_TYPE.PERSON) {
            // Check the data type again to access discipline properties accordingly.
            /* const disciplineCode = dataType === PROCESSING_TYPE.PERSON ? Array.isArray(dataItem?.disciplines) && dataItem?.disciplines[0]?.code : dataItem?.discipline?.code;
            const disciplineDescription = dataType === PROCESSING_TYPE.PERSON ? Array.isArray(dataItem?.disciplines) && dataItem?.disciplines[0]?.description : dataItem?.discipline?.description;*/
            //const disciplineCode = Array.isArray(dataItem?.disciplines) && dataItem?.disciplines[0]?.code;
            //const disciplineDescription = Array.isArray(dataItem?.disciplines) && dataItem?.disciplines[0]?.description;

            // Initialize gender counts for each NOC if not already present.
            if (!genderCountsByNOC[nocCode]) {
                genderCountsByNOC[nocCode] = {
                    M: 0,
                    F: 0,
                    T: 0,
                };
            }

            // Update gender-specific and total counts for the NOC.
            genderCountsByNOC[nocCode][gender]++;
            genderCountsByNOC[nocCode].T++;
        }
    });

    // Convert genderCountsByNOC to the desired format and build the results array.
    for (const nocCode in genderCountsByNOC) {
        let orgs = filterData?.find(dataItem => dataItem?.organisation?.code === nocCode)?.organisation;
        /*const nocObj = {
            code: nocCode,
            description: filterData?.find(dataItem => dataItem?.organisation?.code === nocCode)?.organisation?.description || '',
            longDescription: filterData?.find(dataItem => dataItem?.organisation?.code === nocCode)?.organisation?.longDescription || ''
        };*/
        if (nocCode !== undefined && orgs!== undefined) {
            results.push({
                organisation: orgs,
                gender: genderCountsByNOC[nocCode]
            });
        }
    }

    // Return the processed data.
    return results;
}

function calculateFooterData(dataState) {
    const footerData = [
        {
            id: 'Noc',
            calculate: (dataState) => 'Total',
        },
        {
            id: 'M',
            calculate: (dataState) => dataState.reduce((total, row) => total + (row.gender.M || 0), 0),
        },
        {
            id: 'F',
            calculate: (dataState) => dataState.reduce((total, row) => total + (row.gender.F || 0), 0),
        },
        {
            id: 'T',
            calculate: (dataState) => dataState.reduce((total, row) => total + (row.gender.T || 0), 0),
        },
    ];
    return footerData;
}


